import { Container } from '@mui/material';
import ContactForm from '../components/ContactForm';

const ContactPage = () => (
    <Container maxWidth="md" sx={{ pt: 6, pb: 8 }}>
        <ContactForm />
    </Container>
);

export default ContactPage;
